import api from './api';

// Shared date-range params — every comeback endpoint accepts an optional
// startDate/endDate pair (YYYY-MM-DD) so the whole page can be scoped to a range.
function dateParams({ startDate, endDate } = {}) {
  return {
    ...(startDate && { startDate }),
    ...(endDate && { endDate }),
  };
}

export const comebackService = {
  async list({ page = 1, limit = 10, search = '', startDate, endDate } = {}) {
    const response = await api.get('/comeback', {
      params: { page, limit, ...(search && { search }), ...dateParams({ startDate, endDate }) }
    });
    return response.data;
  },

  async getAbandonedStepStats({ startDate, endDate } = {}) {
    const response = await api.get('/comeback/stats/abandoned-steps', {
      params: dateParams({ startDate, endDate })
    });
    return response.data;
  },

  async getAbandonedStepsTimeline({ startDate, endDate } = {}) {
    const response = await api.get('/comeback/stats/abandoned-steps-timeline', {
      params: dateParams({ startDate, endDate })
    });
    return response.data;
  },

  async getAbandonedStepsVsQuotesTimeline({ startDate, endDate } = {}) {
    const response = await api.get('/comeback/stats/abandoned-steps-vs-quotes-timeline', {
      params: dateParams({ startDate, endDate })
    });
    return response.data;
  },

  async getBreakdowns({ startDate, endDate } = {}) {
    const response = await api.get('/comeback/stats/breakdowns', {
      params: dateParams({ startDate, endDate })
    });
    return response.data;
  },

  async delete(id) {
    const response = await api.delete(`/comeback/${encodeURIComponent(id)}`);
    return response.data.data;
  }
};
